var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { Button, NumberFormatField } from "@savvyinsure/react-ui";
import { EXPERIENCE, InsuranceProducts } from "../../../constants";
import { PivotReason, selectInsuranceProduct, } from "../../../features/applicant/applicantSlice";
import { agentBundleUpsell, saveHomeowners, skippedHomePremium, } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import { completedPage, specifyMonthlyPolicyPremium } from "../../../lib/Avo";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import { NOT_INSURED_ISSUER_SLUG } from "../../../lib/constants";
import { PHASE } from "../../../routeConfig";
import { TermOptions } from "../../../features/unlinked-application/constants";
import { calculatePremiumAmount } from "../../../utils/calculate";
import { convertDollarsToCents } from "../../../lib/util";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
var I_DONT_KNOW = "I don't know";
var INSURED_HEADER_CONTENT = "If you stay with your current home insurance, how much will it cost every";
var UNINSURED_HEADER_CONTENT = "How much do you expect to pay for home insurance every";
export function useHomePremiumNextRoute() {
    return useAppSelector(function (state) {
        var isAutoOnlyOwnHomePivot = state.applicant.bundlePivotReason === PivotReason.OwnHome;
        var isPrefill = state.configuration.experience === EXPERIENCE.PREFILL;
        var isHomeOnlyApplicant = state.applicant.insuranceProduct === InsuranceProducts.Home;
        var isSavvyAgent = state.configuration.isSavvyAgent;
        if (isSavvyAgent && !isHomeOnlyApplicant) {
            return PHASE.UNLINKED_APPLICATION_AUTO_MILITARY;
        }
        if (isAutoOnlyOwnHomePivot) {
            return isPrefill
                ? PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER
                : PHASE.UNLINKED_APPLICATION_AUTO_REVIEW;
        }
        return isHomeOnlyApplicant
            ? PHASE.UNLINKED_APPLICATION_HOMEOWNERS_BUNDLE_AUTO
            : PHASE.UNLINKED_APPLICATION_HOMEOWNERS_POLICY_HOLDER;
    });
}
export default function UnlinkedApplicationHomeownersPremium() {
    var _this = this;
    var _a, _b;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _c = useAppSelector(function (state) { return state.unlinkedApplication; }), entryAction = _c.entryAction, homeowners = _c.homeowners;
    var currentIssuer = useAppSelector(function (state) { return state.applicant; }).currentIssuer;
    var push = useHistory().push;
    var dispatch = useAppDispatch();
    var isAutoOnlyOwnHomePivot = useAppSelector(function (state) { return state.applicant.bundlePivotReason === PivotReason.OwnHome; });
    var isPrefill = useAppSelector(function (state) { return state.configuration.experience === EXPERIENCE.PREFILL; });
    var nextRoute = useHomePremiumNextRoute();
    var isSavvyAgent = useAppSelector(function (state) { return state.configuration.isSavvyAgent; });
    var isAutoShopper = useAppSelector(function (state) { return state.applicant.insuranceProduct === InsuranceProducts.Auto; });
    var _d = useForm({
        defaultValues: {
            premium: (_a = homeowners.premium) === null || _a === void 0 ? void 0 : _a.toString(),
            term: homeowners.term || TermOptions.TwelveMonths,
            termMonth: 12,
        },
        mode: "onChange",
    }), register = _d.register, _e = _d.formState, errors = _e.errors, isValid = _e.isValid, handleSubmit = _d.handleSubmit, setFocus = _d.setFocus, watch = _d.watch;
    var isInsured = ((_b = currentIssuer.home) === null || _b === void 0 ? void 0 : _b.id) !== NOT_INSURED_ISSUER_SLUG;
    var yearlyPremiumAmount = register("premium", {
        required: true,
        setValueAs: function (value) {
            return value.replace(/,/g, "");
        },
        validate: {
            isPositive: function (val) {
                var amount = Number(val);
                return ((Number.isInteger(amount) && amount > 0) ||
                    "Please enter a positive premium amount");
            },
        },
    });
    var _f = watch(["premium", "term"]), premiumValue = _f[0], termValue = _f[1];
    var headerV3 = entryAction === "not-insured"
        ? UNINSURED_HEADER_CONTENT
        : INSURED_HEADER_CONTENT;
    var paymentPeriod = termValue === TermOptions.Monthly
        ? "month"
        : termValue === TermOptions.TwelveMonths
            ? "year"
            : "6 months";
    function sendAnalytics(premiumAmount) {
        var hasPremium = typeof premiumAmount === "number";
        var monthlyPremiumAmount = hasPremium
            ? convertDollarsToCents(premiumAmount)
            : undefined;
        var selectedOption = hasPremium ? "".concat(monthlyPremiumAmount) : I_DONT_KNOW;
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: selectedOption, optionSelected: selectedOption }));
        specifyMonthlyPolicyPremium(__assign(__assign({}, commonAnalyticsProperties), { monthlyPremiumAmount: premiumAmount
                ? convertDollarsToCents(premiumAmount)
                : undefined, isInsured: isInsured, clickedIDontKnow: !hasPremium }));
    }
    var handleSubmitForm = handleSubmit(function (formData, event) { return __awaiter(_this, void 0, void 0, function () {
        var premium, term, termMonth, premiumNumber;
        return __generator(this, function (_a) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            premium = formData.premium, term = formData.term, termMonth = formData.termMonth;
            if (!premium || !term)
                return [2 /*return*/];
            premiumNumber = +premium;
            sendAnalytics(calculatePremiumAmount(+premium, +term));
            dispatch(saveHomeowners({ premium: premiumNumber, termMonth: termMonth, term: term }));
            if (isSavvyAgent && isAutoShopper) {
                dispatch(agentBundleUpsell());
            }
            if (isAutoOnlyOwnHomePivot) {
                dispatch(selectInsuranceProduct({
                    product: InsuranceProducts.AutoHome,
                    changeRoute: false,
                }));
            }
            push(nextRoute);
            return [2 /*return*/];
        });
    }); });
    function handleOnCloseHeader() {
        if (!premiumValue || !termValue)
            return;
        dispatch(saveHomeowners({
            premium: +premiumValue,
            term: termValue,
            termMonth: +termValue,
        }));
    }
    React.useEffect(function () {
        setTimeout(function () { return setFocus("premium"); }, 200);
    }, [setFocus]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { onClose: handleOnCloseHeader, showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, null,
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement("div", { className: "mb-4 flex-none pt-4" },
                    React.createElement(UnlinkedApplicationForm.Header, { className: "mb-1" }, "".concat(headerV3, " ").concat(paymentPeriod, "?")),
                    "If you don't know the exact amount, an estimate is okay!"),
                React.createElement("form", { className: "mb-4 space-y-4", action: "#", onSubmit: handleSubmitForm },
                    React.createElement("div", { className: "relative" },
                        React.createElement("span", { className: "absolute right-[16px] top-1/2 z-10 mt-[1px] -translate-y-1/2 transform" },
                            "/",
                            paymentPeriod),
                        React.createElement(NumberFormatField, __assign({ id: "yearlyPremiumAmount", label: "Estimated Amount", maxLength: termValue === TermOptions.Monthly ? 5 : 6, inputPrefix: "$", "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.premium), defaultValue: premiumValue !== null && premiumValue !== void 0 ? premiumValue : undefined, thousandSeparator: "," }, yearlyPremiumAmount))),
                    React.createElement("div", { className: "space-y-4" },
                        React.createElement(Button, { disabled: !isValid, id: "continue" }, "Continue"),
                        isAutoOnlyOwnHomePivot ? (React.createElement(Button, { variant: "text", type: "button", onClick: function () {
                                sendAnalytics();
                                dispatch(skippedHomePremium());
                                push(isPrefill
                                    ? PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER
                                    : PHASE.UNLINKED_APPLICATION_AUTO_REVIEW);
                            }, className: "mx-auto" }, "I don't know")) : null))))));
}
